import React, { useState, useContext, useEffect } from "react";
import {
  DotsLoader,
  Footer,
  Header,
  ImageMultiAvatar,
  LocationSearch,
} from "../../components";
import "./styles.css";
import { Images } from "../../theme";
import { useTranslation } from "react-i18next";
import { Link, useLocation } from "react-router-dom";
import { Modal } from "react-responsive-modal";
import InputTextCustom from "../../components/InputTextCustom";
import { GlobalContext } from "../../context/GlobalContext";

export default function Listanitem(props) {
  const createUpdateItem = useContext(GlobalContext);
  let {
    get_categories,
    create_item_by_user_id,
    get_specific_item,
    categoryData,
    imageUrl,
    specificItemData,
    secondLoader,
    isLoading,
    update_item_by_user_id,
  } = createUpdateItem;
  const location = useLocation();
  let propsData = location.state?.item;
  const { t } = useTranslation();

  const [confirmModal, setConfirmModal] = useState(false);
  const [locationModal, setLocationModal] = useState(false);
  const [formData, setFormData] = useState({});
  const [formErrors, setFormErrors] = useState({});
  const [image, setImage] = useState([]);
  const [deleteImage, setDeleteImage] = useState([]);
  const [loginResponse, setLoginResponse] = useState(false);
  const [locationvalue, setLocationvalue] = useState("");
  const onCloseConfirmModal = () => setConfirmModal(false);
  const onCloseLocationModal = () => setLocationModal(false);

  useEffect(() => {
    propsData?.id && get_specific_item(propsData?.id);
    get_categories();
    window.scrollTo(0, 0);

    let userData = sessionStorage.getItem("user");
    userData && setLoginResponse(JSON.parse(userData));
  }, []);

  useEffect(() => {
    if (specificItemData.id) {
      setLocationvalue(specificItemData?.location);
      setFormData(specificItemData);
      let multiImages = specificItemData?.images?.map((str, index) => ({
        src: `${imageUrl}${str}`,
        str: str,
        id: index + 1,
        updateData: true,
      }));
      setImage(multiImages);
    } else {
      setLocationvalue("");
      setFormData({});
    }
  }, [specificItemData]);

  async function onChangeInput(data) {
    setFormErrors(false);
    const { selectedInput } = data;
    let upData = { ...formData };
    upData[selectedInput] = data.value;
    data.state(upData);
  }

  function imageData(image) {
    setImage(image);
  }

  function deletedImage(image) {
    setDeleteImage([...deleteImage, image]);
  }

  function renderLocaton(value) {
    setFormData({ ...formData, longitude: value.lng, latitude: value.lat });
  }
  function checkValidation() {
    let {
      title,
      daily_price,
      weekly_price,
      monthly_price,
      market_value,
      quantity,
      minimun_rental_period,
      description,
      category_id,
      latitude,
      longitude,
      id,
    } = formData;

    if (image.length < 1) {
      alert(t("Image_Required"));
    } else if (!title) {
      setFormErrors({ ...formErrors, titleError: t("Title_Required") });
      window.scrollTo(0, 0);
    } else if (!category_id) {
      setFormErrors({ ...formErrors, categoryError: t("Category_Required") });
      window.scrollTo(0, 0);
    } else if (!daily_price) {
      setFormErrors({
        ...formErrors,
        dailyPriceError: t("Daily_Price_Required"),
      });
      window.scrollTo(0, 0);
    } else if (daily_price < 1) {
      setFormErrors({
        ...formErrors,
        dailyPriceError: t("Daily_Price_Required"),
      });
      window.scrollTo(0, 0);
    } else if (!weekly_price) {
      setFormErrors({
        ...formErrors,
        weeklyPriceError: t("Weekly_Price_Required"),
      });
      window.scrollTo(0, 0);
    } else if (weekly_price < 1) {
      setFormErrors({
        ...formErrors,
        weeklyPriceError: t("Weekly_Price_Required"),
      });
      window.scrollTo(0, 0);
    } else if (!monthly_price) {
      window.scrollTo(0, 0);
      setFormErrors({
        ...formErrors,
        monthlyPriceError: t("Monthly_Price_Required"),
      });
    } else if (monthly_price < 1) {
      window.scrollTo(0, 0);
      setFormErrors({
        ...formErrors,
        monthlyPriceError: t("Monthly_Price_Required"),
      });
    } else if (!market_value) {
      window.scrollTo(0, 0);
      setFormErrors({
        ...formErrors,
        marketValueError: t("Market_Value_Required"),
      });
    } else if (market_value < 1) {
      window.scrollTo(0, 0);
      setFormErrors({
        ...formErrors,
        marketValueError: t("Market_Value_Required"),
      });
    } else if (!quantity) {
      window.scrollTo(0, 0);
      setFormErrors({
        ...formErrors,
        quantityError: t("Quantity_Required"),
      });
    } else if (quantity < 1) {
      window.scrollTo(0, 0);
      setFormErrors({
        ...formErrors,
        quantityError: t("Quantity_Required"),
      });
    } else if (!minimun_rental_period) {
      window.scrollTo(0, 0);
      setFormErrors({
        ...formErrors,
        minRentalError: t("Rental_Period_Required"),
      });
    } else if (minimun_rental_period < 1) {
      setFormErrors({
        ...formErrors,
        minRentalError: t("Rental_Period_Required"),
      });
    } else if (!locationvalue) {
      setFormErrors({
        ...formErrors,
        locationError: t("Please_Select_Location"),
      });
    } else if (!description) {
      setFormErrors({
        ...formErrors,
        descriptionError: t("Description_Required"),
      });
    } else {
      let formData = new FormData();
      formData.append("title", title);
      formData.append("category_id", category_id);
      formData.append("daily_price", daily_price);
      formData.append("weekly_price", weekly_price);
      formData.append("monthly_price", monthly_price);
      formData.append("market_value", market_value);
      formData.append("quantity", quantity);
      formData.append("minimun_rental_period", minimun_rental_period);
      formData.append("longitude", longitude);
      formData.append("location", locationvalue);
      formData.append("latitude", latitude);
      formData.append("description", description);
      formData.append("user_id", loginResponse.id);
      image.length &&
        image.forEach((img) => {
          if (img.file?.name) formData.append("images[]", img.file);
        });
      if (id) {
        formData.append("item_id", id);
        deleteImage.length &&
          deleteImage.forEach((img) => {
            if (img.str) formData.append("removed_images[]", img.str);
          });
        update_item_by_user_id(formData);
      } else create_item_by_user_id(formData);

      // setConfirmModal(true);
    }
  }

  return (
    <>
      <Header />
      <div className="container">
        <div className="row">
          <div className="col-md-12 mt-5 mb-3">
            <span className={"DescriptionHeading"}>{t("List_An_Item")}</span>
            <hr />
          </div>
        </div>
      </div>

      {secondLoader ? (
        <DotsLoader />
      ) : (
        <div className="container">
          <div className="row">
            <div className="col-md-9">
              <div className="row listBoxNew">
                {formData.id ? (
                  <div>
                    <img src={Images.ratingIcon} alt="image" />
                    <span className="ratingOwerText">
                      {formData.rating ? formData.rating : 0}
                    </span>
                  </div>
                ) : null}
                <div className="col-md-6">
                  <InputTextCustom
                    headingLabel={t("Title")}
                    placeholder={t("Name_Of_Product")}
                    value={formData.title}
                    errorState={formErrors.titleError}
                    onChange={(e) => {
                      onChangeInput({
                        value: e.target.value,
                        state: setFormData,
                        selectedInput: "title",
                        selectedRow: formData,
                      });
                    }}
                  />
                </div>
                <div className="col-md-6">
                  <label class="control-label customStyleLabel">
                    {t("Category")}
                  </label>
                  <select
                    value={formData.category_id}
                    onChange={(e) => {
                      onChangeInput({
                        value: e.target.value,
                        state: setFormData,
                        selectedInput: "category_id",
                        selectedRow: formData,
                      });
                    }}
                    class="form-select customStyleInput"
                    id="inputGroupSelect01"
                  >
                    <option value="null">{t("Select_Cetegory")}</option>
                    {categoryData?.map(({ name, id }) => {
                      return <option value={id}>{name}</option>;
                    })}
                  </select>
                  {formErrors.categoryError && (
                    <div style={{ color: "red", fontSize: 12 }}>
                      {formErrors.categoryError}
                    </div>
                  )}
                </div>
                <label class="control-label customStyleLabelNew">
                  {t("Rental_Price")} {t("HKD")}
                </label>

                <div className="col-md-6">
                  {/* <label class="control-label customStyleLabelNew">
                    Rental Price (HKD)
                  </label> */}
                  <div className="row">
                    <div className="col-md-4 col-4">
                      <InputTextCustom
                        headingLabel={t("Daily")}
                        placeholder={t("Daily")}
                        className="form-control customStyleInput"
                        value={formData.daily_price}
                        type="number"
                        min={0}
                        errorState={formErrors.dailyPriceError}
                        onChange={(e) => {
                          onChangeInput({
                            value: e.target.value,
                            state: setFormData,
                            selectedInput: "daily_price",
                            selectedRow: formData,
                          });
                        }}
                      />
                    </div>
                    <div className="col-md-4 col-4">
                      <InputTextCustom
                        headingLabel={t("Weekly")}
                        placeholder={t("Weekly")}
                        className="form-control customStyleInput"
                        value={formData.weekly_price}
                        type="number"
                        min={0}
                        errorState={formErrors.weeklyPriceError}
                        onChange={(e) => {
                          onChangeInput({
                            value: e.target.value,
                            state: setFormData,
                            selectedInput: "weekly_price",
                            selectedRow: formData,
                          });
                        }}
                      />
                    </div>
                    <div className="col-md-4 col-4">
                      <InputTextCustom
                        headingLabel={t("Monthly")}
                        placeholder={t("Monthly")}
                        className="form-control customStyleInput"
                        value={formData.monthly_price}
                        type="number"
                        min={0}
                        errorState={formErrors.monthlyPriceError}
                        onChange={(e) => {
                          onChangeInput({
                            value: e.target.value,
                            state: setFormData,
                            selectedInput: "monthly_price",
                            selectedRow: formData,
                          });
                        }}
                      />
                    </div>
                    <div className="col-md-3"></div>
                  </div>
                </div>

                <div className="col-md-3">
                  <InputTextCustom
                    headingLabel={t("Market_Value") + t("HKD")}
                    placeholder="4322"
                    className="form-control customStyleInput"
                    labelClass="customStyleLabelNew"
                    value={formData.market_value}
                    type="number"
                    min={0}
                    errorState={formErrors.marketValueError}
                    onChange={(e) => {
                      onChangeInput({
                        value: e.target.value,
                        state: setFormData,
                        selectedInput: "market_value",
                        selectedRow: formData,
                      });
                    }}
                  />
                </div>
                <div className="col-md-3">
                  <InputTextCustom
                    headingLabel={t("Quantity")}
                    placeholder="1"
                    className="form-control customStyleInput"
                    labelClass="customStyleLabelNew"
                    value={formData.quantity}
                    type="number"
                    min={0}
                    errorState={formErrors.quantityError}
                    onChange={(e) => {
                      onChangeInput({
                        value: e.target.value,
                        state: setFormData,
                        selectedInput: "quantity",
                        selectedRow: formData,
                      });
                    }}
                  />
                </div>

                <div className="col-md-6 col-12">
                  <InputTextCustom
                    headingLabel={t("Minimum_Rental_Days")}
                    placeholder={t("What_is_Minimum_Days_Period")}
                    value={formData.minimun_rental_period}
                    type="number"
                    min={0}
                    errorState={formErrors.minRentalError}
                    onChange={(e) => {
                      onChangeInput({
                        value: e.target.value,
                        state: setFormData,
                        selectedInput: "minimun_rental_period",
                        selectedRow: formData,
                      });
                    }}
                  />
                </div>
                <div className="col-md-6 col-12">
                  <label className="control-label customStyleLabel">
                    {t("Location")}
                  </label>
                  <Link to="" onClick={() => setLocationModal(true)}>
                    <button className="btn location-btn">
                      {locationvalue || t("Where_Is_Product_Located")}
                    </button>
                  </Link>
                  {formErrors.locationError && (
                    <div style={{ color: "red", fontSize: 12 }}>
                      {formErrors.locationError}
                    </div>
                  )}
                </div>
                <div className="col-md-12 col-12">
                  <label class="control-label customStyleLabel">
                    {t("Description")}
                  </label>
                  <div>
                    <textarea
                      id="w3review"
                      name="w3review"
                      rows="4"
                      placeholder={t("Tell_Product_Description")}
                      className="form-control textAreaStyle"
                      value={formData.description}
                      onChange={(e) => {
                        onChangeInput({
                          value: e.target.value,
                          state: setFormData,
                          selectedInput: "description",
                          selectedRow: formData,
                        });
                      }}
                    />
                    {formErrors.descriptionError && (
                      <div style={{ color: "red", fontSize: 12 }}>
                        {formErrors.descriptionError}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>

            <div className="col-md-3">
              {formData.id ? (
                <>
                  <div className="EditItemlocationRight">
                    <img
                      className="EditItemlocationIcon"
                      src={Images.locationIcon}
                      alt="image"
                    />
                    <span className="EditItemlocationText">
                      {locationvalue}
                    </span>
                  </div>
                  <div className="EditItemlocationRight mt-3">
                    <button className="EditbtnActiveRental">
                      {t("Active_Rental")}
                    </button>
                  </div>
                </>
              ) : null}
              <ImageMultiAvatar
                imageData={imageData}
                deletedImage={deletedImage}
                source={image}
              />
            </div>
          </div>
          <div className="row mt-4 mb-5">
            <div className="col-md-12" style={{ textAlign: "end" }}>
              <button
                class="btn-custom btn-light"
                disabled={isLoading}
                onClick={() => checkValidation()}
              >
                {isLoading ? <DotsLoader /> : t("List_An_Item")}
              </button>
            </div>
          </div>
        </div>
      )}

      <Footer />
      <Modal
        classNames={{ modal: "categoryModal" }}
        open={confirmModal}
        onClose={onCloseConfirmModal}
        center
      >
        <div className="row">
          <div className="col-lg-8 offset-lg-2">
            <Link to="">
              <div>
                <img
                  className="text-center d-block m-auto confirmImg mt-4"
                  src={Images.confirm}
                />
                <p class="text-center confirm-txt poppins mt-5">
                  {t("List_An_Modal_1")} <br />
                  {t("List_An_Modal_2")}
                </p>
                <div className="row mt-5 mb-4">
                  <div className="col-lg-6 col-6">
                    <button
                      type="button"
                      class="btn-rent w-100 btn btn-outline-primary"
                    >
                      {t("Rent_More")}
                    </button>
                  </div>
                  <div className="col-lg-6 col-6">
                    <button class="btn-start btn-light w-100">
                      {t("Start_Lending")}
                    </button>
                  </div>
                </div>
              </div>
            </Link>
          </div>
        </div>
      </Modal>
      <Modal
        classNames={{
          modal: "locationModal",
        }}
        open={locationModal}
        onClose={onCloseLocationModal}
        center
      >
        <LocationSearch
          locationLatLng={renderLocaton}
          locationData={setLocationvalue}
          value={locationvalue}
          onClose={onCloseLocationModal}
        />
      </Modal>
    </>
  );
}
